import ChequeRow from "./ChequeRow";

export default ChequeRow;
